<ng-container *transloco="let t">
  <authority-labs-base-dialog [dialogRef]="dialogRef" title="צ'קליסט">
    <div content class="content" id="previewFrame">
      <mat-progress-spinner
        *ngIf="inProgress"
        mode="indeterminate"
        strokeWidth="3"
        diameter="50"
      >
      </mat-progress-spinner>
      <mat-form-field appearance="fill" *ngIf="isNew">
        <mat-label>סוג הבדיקה</mat-label>
        <mat-select
          [(ngModel)]="inspectionType"
          (selectionChange)="onInspectionTypeChange()"
        >
          <mat-option
            *ngFor="let item of inspectionTypes | values"
            [value]="item"
          >
            {{ item }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <button actions nz-button [nzLoading]="downloading" (click)="exportToPdf()">
      יצא ל PDF
    </button>
  </authority-labs-base-dialog>
</ng-container>
